export default "__VITE_ASSET__D1u1LsSc__"